import React, { useState, useEffect } from "react";
import "./Contact.css";
import messageImg from "../../Assets/vectors/contact.svg";
import location from "../../Assets/vectors/Icons/location.svg";
import phoneImg from "../../Assets/vectors/Icons/phone.svg";
import mail from "../../Assets/vectors/Icons/mail.svg";
import Map from "../../Components/Map/Map";

export default function Contact() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="mainContainer contact">
      {/* <PageIntro image={contact} text="Contact" /> */}
      <div className="grid grid2Fr">
        <div className="flex flexColumn contactInfo">
          <img src={messageImg} alt="" />
          <h1 className="mt1">Contact Info:</h1>
          <p className="mb1 mt05">
            For any kind of query and clarification please contact with us
            without any hesitation.
          </p>
          <div className="footer-contact" style={{ fontSize: "16px" }}>
            <div>
              <img src={location} alt="" />
              <span>Via Tiburtina ‎605 - Roma, Zip 00159, Italy</span>
            </div>
            <div>
              <img src={mail} alt="" />
              <a href="mailto:admin@madanischoolandcollege.com">
                admin@madanischoolandcollege.com
              </a>
            </div>
            <div>
              <img src={phoneImg} alt="" />
              <a href="tel:+393895097764">+39 389 5097764</a>
            </div>
          </div>
        </div>
        <div className="contactForm">
          <div className="card">
            <div className="grid grid2Fr mb1" style={{ gap: "1rem" }}>
              <div className="">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="phone">Phone</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone"
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>
            <div>
              <div className="mb1">
                <label htmlFor="message">Message</label>
                <textarea
                  name="message"
                  onChange={(e) => setMessage(e.target.value)}
                  id=""
                  rows="5"
                  placeholder="Description"
                ></textarea>
              </div>
              <span className="contactNote">
                Our service executive will contact with you through your email
                or phone after receiving your message.
              </span>
              <a
                href={`mailto:admin@madanischoolandcollege.com?subject=${
                  name + " - " + phone
                }&body=${message}`}
              >
                <button className="bt ripple mt1 mb1" style={{ width: "100%" }}>
                  Send Message
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Map />
    </div>
  );
}
